// @flow
import { createContext } from 'react';

export const SPMetaDataContext = createContext({});
